





























import Vue from 'vue'

import { MAGAZINE_TYPES, MAGAZINE_TITLES } from '@/magazine/consts'
import { MagazineCard } from '@/magazine/types'

import MagazineItem from '@/common/components/magazine/MagazineItem.vue'
import Carousel from '@/common/components/Carousel.vue'

const DESKTOP_BREAKPOINT = 1024

export default Vue.extend({
  components: { MagazineItem, Carousel },
  props: {
    magazineType: {
      type: String,
      required: true
    },
    magazines: {
      type: Array as () => MagazineCard[],
      default: () => []
    }
  },
  computed: {
    magazineTypes(): { [key: string]: string } {
      return MAGAZINE_TYPES
    },
    sectionTitle(): string {
      switch (this.magazineType) {
        case MAGAZINE_TYPES.COLUMN:
          return MAGAZINE_TITLES.COLUMN
        case MAGAZINE_TYPES.FEATURE:
          return MAGAZINE_TITLES.FEATURE
        case MAGAZINE_TYPES.CUSTOMER:
          return MAGAZINE_TITLES.CUSTOMER
        case MAGAZINE_TYPES.CATEGORY:
          return MAGAZINE_TITLES.CATEGORY
        default:
          return ''
      }
    },
    isDesktopView(): boolean {
      return window.innerWidth > DESKTOP_BREAKPOINT
    },
    slidesPerView(): number {
      return this.isDesktopView ? 3 : 1
    }
  }
})
